import { io } from 'socket.io-client';

import { API_BASE } from './config';
import { getAccessToken } from '../storage/tokens';

// socket.io attaches directly to the HTTP server (sus_sprout_server's
// server.js), a sibling to the Express /api routes rather than nested under
// /api itself — so the socket origin is API_BASE with the trailing /api
// stripped (chat_bot_implementation.md Phase 8).
const SOCKET_ORIGIN = API_BASE.replace(/\/api\/?$/, '');

// `auth` as a function (not a plain object) so it's re-evaluated on every
// (re)connection attempt, not just the first — a plain object is captured
// once at the moment connectChatSocket() is called and Socket.IO resends
// that same stale value on every auto-reconnect afterward. Without this, a
// long-idle tab (the Chat Handoff list, chat_bot.md — same class of problem
// as the print designer's proactive HTTP refresh in api/client.js) would
// reconnect with the original token even after the app's silent refresh
// timer has since rotated it in storage, and get stuck permanently
// unauthorized until the page is reloaded.
export const connectChatSocket = () =>
  io(SOCKET_ORIGIN, {
    auth: (cb) => cb({ token: getAccessToken() }),
  });
